import React from 'react';

export const LazyBody = React.lazy(() => import('./Body'));
